/**
 * 勤務時間申告書 — exact match to the Excel template provided by user.
 */
export default function WorkDeclarationPrintSheet({ submission }) {
  const data = submission.form_data || {};
  const today = new Date(submission.created_at);
  const reiwa = today.getFullYear() - 2018;
  const submitDate = `令和${reiwa}年${today.getMonth() + 1}月${today.getDate()}日`;

  const od = data.occurrence_date ? new Date(data.occurrence_date) : null;
  const validOd = od && !isNaN(od.getTime());
  const occY = validOd ? od.getFullYear() : '';
  const occM = validOd ? od.getMonth() + 1 : '';
  const occD = validOd ? od.getDate() : '';

  const reasonType = data.reason_type || '';
  const startH = data.actual_start_time ? parseInt(data.actual_start_time.split(':')[0], 10) : '';
  const startM = data.actual_start_time ? parseInt(data.actual_start_time.split(':')[1], 10) : '';
  const endH = data.actual_end_time ? parseInt(data.actual_end_time.split(':')[0], 10) : '';
  const endM = data.actual_end_time ? parseInt(data.actual_end_time.split(':')[1], 10) : '';

  const Circle = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
      <circle cx="11" cy="11" r="9" fill="none" stroke="#000" strokeWidth="1.3" />
    </svg>
  );

  const ReasonItem = ({ num, active, children }) => (
    <div style={{ display: 'flex', alignItems: 'center', minHeight: '24px', borderBottom: '1px solid #000', fontSize: '11px' }}>
      <div style={{ position: 'relative', width: '40px', textAlign: 'center', borderRight: '1px solid #000', padding: '4px 0' }}>
        <span style={{ position: 'relative', zIndex: 1 }}>{num}.</span>
        {active && <Circle />}
      </div>
      <div style={{ flex: 1, padding: '4px 8px' }}>{children}</div>
    </div>
  );

  const cell = { border: '1px solid #000', padding: '4px 8px', fontSize: '11px' };

  return (
    <div
      className="print-form bg-white"
      style={{
        padding: '24px 28px',
        fontFamily: "'IBM Plex Sans JP', 'Yu Gothic', sans-serif",
        color: '#000',
        background: '#fff',
      }}
    >
      {/* Top row: 総務部 殿  (left)   |  date + 印 (right) */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
          <span style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '0.2em' }}>総　務　部</span>
          <span style={{ fontSize: '13px' }}>殿</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px' }}>{submitDate}</span>
        </div>
      </div>

      {/* Title */}
      <h1 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', letterSpacing: '0.25em', margin: '4px 0 14px 0' }}>
        勤務時間申告書
      </h1>

      {/* Intro line */}
      <div style={{ fontSize: '12px', marginBottom: '14px' }}>
        私、下記理由にて勤怠データに不備を発生させましたので勤務時間の申告を致します。
      </div>

      {/* Applicant table — 申告者 spans 2 rows on the left */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '12px' }}>
        <tbody>
          <tr>
            <td rowSpan={2} style={{ ...cell, width: '12%', textAlign: 'center', verticalAlign: 'middle' }}>申告者</td>
            <td style={{ ...cell, width: '12%', textAlign: 'center' }}>ID</td>
            <td style={{ ...cell, width: '18%', textAlign: 'center' }}>個人コード</td>
            <td style={{ ...cell, textAlign: 'center' }}>氏　名</td>
            <td rowSpan={2} style={{ ...cell, width: '8%', textAlign: 'center', verticalAlign: 'middle' }}>印</td>
          </tr>
          <tr>
            <td style={{ ...cell, textAlign: 'center', fontFamily: 'monospace' }}>{data.id_card || ''}</td>
            <td style={{ ...cell, textAlign: 'center' }}>{data.employee_code || ''}</td>
            <td style={{ ...cell, textAlign: 'center', fontWeight: 'bold' }}>{data.employee_name || ''}</td>
          </tr>
          <tr>
            <td style={{ ...cell, textAlign: 'center', fontWeight: 'bold' }}>所属名</td>
            <td colSpan={4} style={{ ...cell, textAlign: 'center', fontWeight: 'bold' }}>{data.department || ''}</td>
          </tr>
        </tbody>
      </table>

      {/* Reason section */}
      <div style={{ fontSize: '12px', marginBottom: '4px' }}>
        勤怠データ不備理由　<span style={{ fontSize: '11px' }}>（いずれかの項目を選択）</span>
      </div>
      <div style={{ border: '1px solid #000', borderBottom: 'none' }}>
        <ReasonItem num="1" active={reasonType === 'スキャン忘れ'}>スキャン忘れ</ReasonItem>
        <ReasonItem num="2" active={reasonType === 'ボタン切り替えミス'}>出退勤ボタン切り替えミスによる出勤時間の消去</ReasonItem>
        <ReasonItem num="3" active={reasonType === '直行・直帰'}>{reasonType === '直行・直帰' ? '直行・直帰' : ''}</ReasonItem>
        <ReasonItem num="4" active={reasonType === 'その他'}>
          その他（{reasonType === 'その他' && data.comments ? data.comments : '　　　　　　　　　　　　　　　　　　　　　　　　　　　　　'}）
        </ReasonItem>
      </div>

      {/* 勤務時間申告欄 */}
      <div style={{ fontSize: '12px', marginTop: '14px', marginBottom: '4px' }}>勤務時間申告欄</div>
      <table style={{ width: '55%', borderCollapse: 'collapse', marginBottom: '12px' }}>
        <tbody>
          <tr>
            <td style={{ ...cell, fontWeight: 'bold', width: '22%' }}>発生日</td>
            <td style={{ ...cell, textAlign: 'center', width: '17%' }}>{validOd ? occY : ''}</td>
            <td style={{ ...cell, width: '5%' }}>年</td>
            <td style={{ ...cell, textAlign: 'center', width: '12%' }}>{validOd ? occM : ''}</td>
            <td style={{ ...cell, width: '5%' }}>月</td>
            <td style={{ ...cell, textAlign: 'center', width: '12%' }}>{validOd ? occD : ''}</td>
            <td style={{ ...cell, width: '5%' }}>日</td>
          </tr>
          <tr>
            <td style={{ ...cell, fontWeight: 'bold' }}>出勤時間</td>
            <td colSpan={2} style={{ ...cell, textAlign: 'center' }}>{startH !== '' ? `${startH}　時` : '　　時'}</td>
            <td colSpan={2} style={{ ...cell, textAlign: 'center' }}>{startM !== '' ? `${startM}　分` : '　　分'}</td>
            <td colSpan={2} style={cell}></td>
          </tr>
          <tr>
            <td style={{ ...cell, fontWeight: 'bold' }}>退勤時間</td>
            <td colSpan={2} style={{ ...cell, textAlign: 'center' }}>{endH !== '' ? `${endH}　時` : '　　時'}</td>
            <td colSpan={2} style={{ ...cell, textAlign: 'center' }}>{endM !== '' ? `${endM}　分` : '　　分'}</td>
            <td colSpan={2} style={cell}></td>
          </tr>
        </tbody>
      </table>

      {/* 本人コメント欄 */}
      <div style={{ fontSize: '12px', marginBottom: '4px' }}>本人コメント欄</div>
      <div style={{ border: '1px solid #000', padding: '10px 12px', minHeight: '60px', fontSize: '12px', whiteSpace: 'pre-wrap', marginBottom: '14px' }}>
        {data.comments || ''}
      </div>

      {/* 所属長コメント */}
      <div style={{ fontSize: '12px', marginBottom: '4px' }}>所属長・コメント及び証明欄</div>
      <div style={{ border: '1px solid #000', padding: '12px', minHeight: '110px', fontSize: '12px' }}>
        <div style={{ marginBottom: '32px' }}>上記申告欄通り勤務したことを証明します。</div>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', gap: '8px', marginBottom: '10px' }}>
          <span>所属名</span>
          <span style={{ borderBottom: '1px dotted #888', flex: 1, minHeight: '16px' }}></span>
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', gap: '4px' }}>
          <span>所属長氏名</span>
          <span style={{ borderBottom: '1px dotted #888', flex: 1, minHeight: '16px' }}></span>
          <span style={{ fontSize: '11px' }}>印</span>
        </div>
      </div>
    </div>
  );
}
